import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";
import { EntOrganicproducers } from "../../../models/organic/organicProducers";
import { EntOrganicproducersFilter } from "../../../models/filters/organicProducers"; 

export const organicproducersApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getOrganicproducersList: builder.query<ResponseDataGet<EntOrganicproducers>, EntOrganicproducersFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.organicproducers }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getOrganicproducersById: builder.query<ResponseDataGet<EntOrganicproducers>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.organicproducers }/${ id }`,
		method: "GET",
	  }),
	}),

	deleteOrganicproducers: builder.mutation<ResponseDataGet<EntOrganicproducers>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.organicproducers }/${ id }`,
		method: "DELETE",
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useDeleteOrganicproducersMutation,
  useLazyGetOrganicproducersListQuery
} = organicproducersApi;
